import React, { useEffect, useState } from 'react'
// import Box from '@material-ui/core/Box'
import useStyles from './style'
// import { Button, Dialog, Icon, IconButton, InputAdornment, Popover, TextField } from '@material-ui/core'
// import { CalendarToday, CheckBox, NavigateBefore, NavigateNext, NextWeekOutlined, SkipPreviousOutlined } from '@material-ui/icons'
import clsx from 'clsx';
import moment from 'moment';
import helper from "@utils/helper";
import { Box, Button, Dialog } from '@mui/material';

const ModalConfirm = ({
    open = true,
    selectedItem,
    handleCancel,
    handleApprove,
    closeModal
}) => {
    const classes = useStyles();
    return (
        <Dialog open={open} className={classes.dialogContent}>
            <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' ,padding: '34px 43px', width: '423px' }}>
                <Box sx={{ fontSize: '24px', fontWeight: '500', color: '#4c4c4c'}}>
                    {selectedItem?.approve ? 'Xác nhận đơn hàng' : 'Từ chối đơn hàng'}
                </Box>
                <Box sx={{ color: selectedItem?.approve ? '#41B60B' : '#C62026', fontSize: '32px', fontWeight: '500', padding: '24px 0px' }}>
                    {selectedItem?.id}
                </Box>
                <Box sx={{ fontSize: '16px', color: '#5d5d5d' }}>
                    {selectedItem?.customerDetail?.email}
                </Box>
                <Box sx={{ fontSize: '16px', color: '#5d5d5d' }}>
                    {helper.formatCash.format(selectedItem?.amount || 0)}
                </Box>
                <Box sx={{ display: 'flex', marginTop: '24px', justifyContent: 'space-between', width: '100%',
                    '& .MuiButton-root': {
                        padding: '5px 30px',
                        width: '48%'
                    }
                }}>
                    <Button onClick={closeModal} variant='contained' style={{background: "#E0E0E0", color:"black"}}>
                        Không
                    </Button>
                    <Button
                        // className={clsx(selectedItem?.approve ? classes.btnSuccess : classes.btnCancel)}
                        style={{color: "white",background : selectedItem?.approve ? "#40B60A" : "#C62026"}}
                        onClick={() => {
                            if (selectedItem?.approve) {
                                handleApprove()
                            } else {
                                handleCancel()
                            }
                        }}
                    >
                        Có
                    </Button>
                </Box>
            </Box>
        </Dialog>
    )
}

ModalConfirm.propTypes = {}

ModalConfirm.defaultProps = {}

export default ModalConfirm;